var React = require('react');

function PhoneInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M16.5789 11.8516C15.4686 11.8516 14.3811 11.6782 13.3503 11.3381C12.8473 11.1647 12.276 11.2983 11.9454 11.6356L9.9019 13.1789C7.55716 11.9274 6.05653 10.4277 4.82212 8.10001L6.32369 6.10485C6.70169 5.72685 6.83718 5.17357 6.67518 4.65537C6.33222 3.618 6.15791 2.52948 6.15791 1.42105C6.15791 0.637565 5.52035 0 4.73686 0H1.42105C0.637565 0 0 0.637565 0 1.42105C0 10.5622 7.4378 18 16.5789 18C17.3624 18 18 17.3624 18 16.5789V13.2726C18 12.4892 17.3624 11.8516 16.5789 11.8516Z","fill":"white"}));
}

PhoneInline.defaultProps = {"width":"18","height":"18","viewBox":"0 0 18 18","fill":"none"};

module.exports = PhoneInline;

PhoneInline.default = PhoneInline;
